var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F6F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6725 9.96771C17.8734 9.8441 18.1267 9.8441 18.3276 9.96771L26.4526 14.9677C26.6908 15.1143 26.8026 15.4012 26.7264 15.6702C26.6503 15.9393 26.4047 16.125 26.1251 16.125H9.87505C9.59543 16.125 9.34983 15.9393 9.27368 15.6702C9.19752 15.4012 9.30935 15.1143 9.54749 14.9677L17.6725 9.96771ZM12.0832 14.875H23.9169L18.0001 11.2339L12.0832 14.875Z",
    fill: "#606DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 14.875C12.7202 14.875 13 15.1548 13 15.5V23.75C13 24.0952 12.7202 24.375 12.375 24.375C12.0298 24.375 11.75 24.0952 11.75 23.75V15.5C11.75 15.1548 12.0298 14.875 12.375 14.875Z",
    fill: "#606DD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 14.875C16.4702 14.875 16.75 15.1548 16.75 15.5V23.75C16.75 24.0952 16.4702 24.375 16.125 24.375C15.7798 24.375 15.5 24.0952 15.5 23.75V15.5C15.5 15.1548 15.7798 14.875 16.125 14.875Z",
    fill: "#606DD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.875 14.875C20.2202 14.875 20.5 15.1548 20.5 15.5V23.75C20.5 24.0952 20.2202 24.375 19.875 24.375C19.5298 24.375 19.25 24.0952 19.25 23.75V15.5C19.25 15.1548 19.5298 14.875 19.875 14.875Z",
    fill: "#606DD2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 14.875C23.9702 14.875 24.25 15.1548 24.25 15.5V23.75C24.25 24.0952 23.9702 24.375 23.625 24.375C23.2798 24.375 23 24.0952 23 23.75V15.5C23 15.1548 23.2798 14.875 23.625 14.875Z",
    fill: "#606DD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 23.75C9.875 23.4048 10.1548 23.125 10.5 23.125H25.5C25.8452 23.125 26.125 23.4048 26.125 23.75C26.125 24.0952 25.8452 24.375 25.5 24.375H10.5C10.1548 24.375 9.875 24.0952 9.875 23.75Z",
    fill: "#606DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.bd1bc2dc1baaf5ced267224560493a60.svg";
export { ForwardRef as ReactComponent };